<template>
    <div class="report">
        <div class="avatar">
            <div class="contianer dfx">
                <el-button class="go_back" @click="goBack">
                <img src="../assets/previous.svg" alt="返回上一级" />
                </el-button>
                <div class="column">{{ column }}</div>
            </div>
        </div>
        <div class="asstes">
          <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
            <el-tab-pane label="粗动作" name="first">
              <el-form ref="form" :model="form" class="item"  v-for="item in inform1" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
                  <div class="text">
                    <div class="name">姓名：{{item.byname}}</div>
                    <div class="sex">性别：{{item.sex}}</div>
                  </div>
                </div>
                <div class="age">
                  <div class="num">年龄：{{item.age}}</div>
                  <el-form-item>
                    <el-button type="primary" @click="goToTargetPage">立即测评</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="细动作" name="second">
              <el-form ref="form" :model="form" class="item"  v-for="item in inform1" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
                  <div class="text">
                    <div class="name">姓名：{{item.byname}}</div>
                    <div class="sex">性别：{{item.sex}}</div>
                  </div>
                </div>
                <div class="age">
                  <div class="num">年龄：{{item.age}}</div>
                  <el-form-item>
                    <el-button type="primary" @click="goToTargetPage">立即测评</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="测评观家" name="third">
              <el-form ref="form" :model="form" class="item"  v-for="item in inform1" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
                  <div class="text">
                    <div class="name">姓名：{{item.byname}}</div>
                    <div class="sex">性别：{{item.sex}}</div>
                  </div>
                </div>
                <div class="age">
                  <div class="num">年龄：{{item.age}}</div>
                  <el-form-item>
                    <el-button type="primary" @click="goToTargetPage">立即测评</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="能量状态" name="fourth">
              <el-form ref="form" :model="form" class="item"  v-for="item in inform1" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
                  <div class="text">
                    <div class="name">姓名：{{item.byname}}</div>
                    <div class="sex">性别：{{item.sex}}</div>
                  </div>
                </div>
                <div class="age">
                  <div class="num">年龄：{{item.age}}</div>
                  <el-form-item>
                    <el-button type="primary" @click="goToTargetPage">立即测评</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="感统年龄" name="fifth">
              <el-form ref="form" :model="form" class="item"  v-for="item in inform1" :key="item.id">
                <div class="vatar">
                  <el-avatar icon="el-icon-user-solid" :size="size" :src="item.user"></el-avatar>
                  <div class="text">
                    <div class="name">姓名：{{item.byname}}</div>
                    <div class="sex">性别：{{item.sex}}</div>
                  </div>
                </div>
                <div class="age">
                  <div class="num">年龄：{{item.age}}</div>
                  <el-form-item>
                    <el-button type="primary" @click="goToTargetPage">立即测评</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </div>
    </div>
</template>
<script>
export default {
  name: 'Datas',
  data () {
    return {
      column: '3-18周岁测评',
      activeName: 'first',
      inform1: [
        { user: require('@/assets/user_avatar01.png'), byname: '乐乐', sex: '男', age: '5岁10月' },
        { user: require('@/assets/user_avatar02.png'), byname: '虫虫', sex: '女', age: '6岁10月' },
        { user: require('@/assets/user_avatar03.png'), byname: '乖乖', sex: '男', age: '5岁10月' },
        { user: require('@/assets/user_avatar04.png'), byname: '瑶瑶', sex: '女', age: '6岁10月' }
      ]
    }
  },
  methods: {
    handleClick (tab, event) {
      console.log(tab, event)
    },
    onSubmit () {
      console.log('submit!')
    },
    enter () {
      this.$router.push({ name: 'table' })
    }
  }
}
</script>
<style>
.report{
  min-height: 100vh;
}
.report .avatar {
  width: 100%;
  background: linear-gradient(90deg, #ff9b00, #accd05);
  padding: 1rem 0;
}
.report .avatar .dfx{
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.report .avatar .go_back{
  width: 1.13rem;
  height: 1.13rem;
  padding: 0;
  background: none;
  border:none;
}
.report .avatar .go_back img{
  width: 100%;
  height: 100%;
}
.report .avatar .column{
  flex: 1;
  text-align: center;
  font-size: 1.13rem;
  font-weight: bold;
  color: #fff;
}
.report .asstes .el-tabs__header{
  width: 100%;
  height: 3.75rem;
  background: #fff;
  border: none;
  border-bottom: 5px solid #efefef;
  margin-bottom: 0;
}
.report .asstes .el-tabs__header .el-tabs__nav-wrap{
  max-width: 1400px;
  height: 100%;
  margin: 0 auto;
}
.report .asstes .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav-scroll{
  height: 100%;
}
.report .asstes .el-tabs__header .el-tabs__nav-wrap .el-tabs__nav{
  width: 100%;
  height: 100%;
  border: none;
  display: flex;
}
.report .asstes .el-tabs__header .el-tabs__nav-wrap .el-tabs__item{
  width: calc(100% / 3);
  height: 100%;
  border: none;
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.report .asstes .el-tabs__header .el-tabs__nav-wrap .el-tabs__item:hover,
.report .asstes .el-tabs__header .el-tabs__nav-wrap .el-tabs__item.is-active{
  color: #ff7200;
}

.report .asstes .el-tabs__content{
  width: 100%;
  background: #fff;
}
.report .asstes .el-tabs__content .el-tab-pane{
  max-width: 1400px;
  margin: 0 auto;
  padding: 3.13rem 0;
}
.report .asstes .el-tabs__content .el-tab-pane .item{
  border-radius: 1.13rem;
  border: 3px solid #ff7200;
  padding: .63rem 1.13rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.report .asstes .el-tabs__content .el-tab-pane .item + .item{
  margin-top: 1.5rem;
}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar{
  display: flex;
  align-items: center;
}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar .el-avatar{
  width: 5.06rem;
  height: 5.06rem;
  margin-right: 1.13rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar .el-avatar img{
  width: 100%;
}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar .text{}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar .text .name{
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
}
.report .asstes .el-tabs__content .el-tab-pane .item .vatar .text .sex{
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
  margin-top: .63rem;
}
.report .asstes .el-tabs__content .el-tab-pane .item .age{}
.report .asstes .el-tabs__content .el-tab-pane .item .age .num{
  font-size: 1.13rem;
  font-weight: bold;
  line-height: 100%;
}
.report .asstes .el-tabs__content .el-tab-pane .item .age .el-button{
  width: 7.63rem;
  height: 2rem;
  background: linear-gradient(0deg,#FF7200 6%,#FF9C00);
  border-radius: 1rem;
  padding: 0;
  margin-top: 1rem;
  border: none;
}
.report .asstes .el-tabs__content .el-tab-pane .item .age .el-button span{
  font-size: 1rem;
  color: #fff;
}

@media (max-width:1556px) {
  .report .asstes .el-tabs__header .el-tabs__nav-wrap,
  .report .asstes .el-tabs__content .el-tab-pane{
    max-width: 90%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Datas.vue